import { translations as activatePage } from './activate-page';
import { translations as alertsPage } from './alerts-page';
import { translations as contactUsPage } from './contact-us-page';
import { translations as faqPage } from './faq-page';
// import { translations as homePage } from './home-page';
// import { translations as homePageV2 } from './home-page-v2';
import { translations as homePageV3 } from './home-page-v3';
import { translations as identityPage } from './identity-page';
import { translations as privacyPolicyPage } from './policy-page';
import { translations as productVideoNonMembers } from './product-video-non-members';
import { translations as productVideoMembers } from './product-video-members';
import { translations as protectionPage } from './protection-page';
import { translations as resourceCentrePage } from './resource-centre';
import { translations as siteFooter } from './site-footer';
import { translations as siteHeader } from './site-header';
import { translations as siteNavbar } from './site-navbar';
import { translations as termsAndConditionsPage } from './terms-conditions-page';
import { translations as termsOfUsePage } from './terms-page';
import { translations as ScamDetectionPage } from './scamdetection-page';

export const translations = {
  global: {
    siteTitle: 'OnGuard',
    pleaseWaitText: 'Please wait',
    requestProcessingWaitText: 'Please wait while your request is <span class="text-nowrap">processed...</span>',
    modalDismissActionText: 'Close',
    genericErrorMessage: 'An error has occurred.',
    genericFormSubmitErrorMessage: 'There was a problem submitting your form. Please call us at 1-866-327-3078 for assistance.',
    idGuardLinkPopupTitle: 'You will now be taken to the Identity Guard website',
    idGuardLinkPopupBody: [
      'You will now be taken to the OnGuard powered by ID Assist online portal to access these services.',
      'The same Terms and Conditions that you agreed to when activating your subscription apply.'
    ].join('\n'),
    bmoIdGuardLinkPopupBody: [
      'Your Monitoring & Alerts benefit is provided by Identity Guard<sup>®</sup>. You will now be taken to the',
      'Identity Guard website to access these services. The same Terms and Conditions that you agreed',
      'to when activating your subscription apply.'
    ].join('\n'),
    okay: 'OK',

    siteHeader,
    siteNavbar,
    siteFooter,

    provinces: [
      { key: 'AB', value: 'Alberta' },
      { key: 'BC', value: 'British Columbia' },
      { key: 'MB', value: 'Manitoba' },
      { key: 'NB', value: 'New Brunswick' },
      { key: 'NL', value: 'Newfoundland and Labrador' },
      { key: 'NT', value: 'Northwest Territories' },
      { key: 'NS', value: 'Nova Scotia' },
      { key: 'NU', value: 'Nunavut' },
      { key: 'ON', value: 'Ontario' },
      { key: 'PE', value: 'Prince Edward Island' },
      { key: 'QC', value: 'Quebec' },
      { key: 'SK', value: 'Saskatchewan' },
      { key: 'YT', value: 'Yukon' }
    ],

    monthNames: [
      // IMPORTANT key must be zero-prefixed
      { key: '01', value: 'January' },
      { key: '02', value: 'February' },
      { key: '03', value: 'March' },
      { key: '04', value: 'April' },
      { key: '05', value: 'May' },
      { key: '06', value: 'June' },
      { key: '07', value: 'July' },
      { key: '08', value: 'August' },
      { key: '09', value: 'September' },
      { key: '10', value: 'October' },
      { key: '11', value: 'November' },
      { key: '12', value: 'December' }
    ]
  },
  pageAccessDenied: {
    pageTitle: 'UH OH!',
    pageContent: [
      '<p>This content is not available in your region.<br/>',
      'If you need assistance while you&#39;re away, please contact 416-734-3904.</p>'
    ].join('\n')
  },
  pageNotFound: {
    docTitle: 'Page not found',
    pageTitle: 'We can&#39;t seem to find the page you are looking for.',
    siteMapTitle: 'Here&#39;s a sitemap instead:'
  },
  // homePage,
  // homePageV2,
  homePageV3,
  productVideoNonMembers,
  productVideoMembers,
  alertsPage,
  identityPage,
  protectionPage,
  activatePage,
  termsAndConditionsPage,
  termsOfUsePage,
  privacyPolicyPage,
  faqPage,
  contactUsPage,
  resourceCentrePage,ScamDetectionPage
};
